export default "__VITE_ASSET__DPzaKTTr__"